import React from "react";
import { useParams } from "react-router-dom";
import ProductLandingPage from "components/ProductLandingPage";
import NotFound from "pages/NotFound";
import { getUseCaseConfig } from "./useCaseConfigs";

export default function UseCasePage() {
    const { slug } = useParams();
    const config = getUseCaseConfig(slug);
    if (!config) return <NotFound />;
    return <ProductLandingPage config={config} />;
}
